import React, { Component } from "react";

function dibujarIconTipo(tipo){
  switch(tipo){
    case "INFO":
      return ("fas fa-exclamation-circle card-fa-icono-info");
    case "WARN":
      return ("alert alert-warning");
    case "ERROR":
      return ("fas fa-exclamation-triangle card-fa-icono-error");
    
  }
}

function dibujarCardTipo(tipo){
  switch(tipo){
    case "INFO":
      return ("callout callout-success");
    case "WARN":
      return ("callout callout-warning");
    case "ERROR":
      return ("callout callout-error");
    
  }
}

export default class MensajeUsuario extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    
  }


  render(props) { 
      return (
        <div className="row">
          <div className="col-md-12">
            <div className={dibujarCardTipo(this.props.tipo)}  className="importante " style={{fontFamily: "Montserrat-Semibold",color:"#E30A0A",fontSize:"16px",padding:"1rem", borderRadius:"5px",boxShadow: "none"}}>
              <div className="row">
                <div className="col-md-12">
                  <i className={dibujarIconTipo(this.props.tipo)} style={{marginRight: 5,fontSize:25}}/> 
                  <p className="title-important">{this.props.titulo}</p> 
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 texto">
                  {this.props.mensaje}
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  {this.props.mensaje2} 
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  {this.props.linkURL!==undefined &&
                    <a className="btn btn-outline-success btn-resolucion" href={this.props.linkURL} target="_blank">
                      <i className="fas fa-link"/> {this.props.linkText}
                    </a> 
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      );
  }
}